export class GetInvoicesRequest {
    KeywordSearches: string[];
    PageNumber: number;
    ItemsPerPage: number;
    StatusFilter: number;
    InvoiceSorting: number;
}
